import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { hideAlertAction } from "store/actions/Actions";

import styles from "./Alert.module.scss"

const Alert = props => {
    const [show, setShow] = useState(false);

    const {
        message, hideAlertAction
    } = props;

    useEffect(() => {
        if (message) {
            window.setTimeout(() => {
                setShow(true);
            }, 10);
        } else {
            setShow(false);
        }
    }, [message]);

    const handleClose = () => {
        hideAlertAction();
    };

    return (props.message &&
        <div onClick={handleClose} className={`${styles.alert} ${props.color ? styles[props.color] : styles.primary} ${show ? styles.show : null}`}>
            {message || "Default message"}
        </div>
    );
}

const mapStateToProps = ({ AlertReducer }) => AlertReducer;

const mapDispatchToProps = {
    hideAlertAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Alert);
